import { Directive, EventEmitter, Input, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { Subject } from 'rxjs';
import { tap, takeUntil, } from 'rxjs/operators';

export interface IAutoCompleteScrollEvent {
  autoComplete: MatAutocomplete;
  scrollEvent: Event;
}

@Directive({
  selector: 'mat-autocomplete[autocompleteScroll]'
})

export class AutocompleteScrollDirective implements OnChanges, OnDestroy {

  @Input() thresholdPercent = .9;
  @Input() isLoading = false;
  @Input() disableLoading = false;

  @Output('autocompleteScroll') scroll = new EventEmitter<IAutoCompleteScrollEvent>();
  _onDestroy = new Subject();

  eleAutocomplete: HTMLInputElement = null;

  constructor(public autoComplete: MatAutocomplete) {
    this.autoComplete.opened.pipe(
      tap(() => {
        // Note: When autocomplete raises opened, panel is not yet created (by Overlay)
        // Note: The panel will be available on next tick
        // Note: The panel wil NOT open if there are no options to display
        setTimeout(() => {
          // Note: remove listner just for safety, in case the close event is skipped.
          this.removeScrollEventListener();
          this.eleAutocomplete = this.autoComplete.panel.nativeElement;
          this.eleAutocomplete.addEventListener('scroll', this.onScroll.bind(this))
        });
      }),
      takeUntil(this._onDestroy)).subscribe();

    this.autoComplete.closed.pipe(
      tap(() => {
        this.removeScrollEventListener();
        this.eleAutocomplete = null;
      }),
      takeUntil(this._onDestroy)).subscribe();
  }

  private removeScrollEventListener() {
    if (this.autoComplete?.panel?.nativeElement)
      this.autoComplete.panel.nativeElement
        .removeEventListener('scroll', this.onScroll);
  }

  ngOnChanges(changes: SimpleChanges): void {
    let isLoadingChange = changes.isLoading;
    if (isLoadingChange && !isLoadingChange.currentValue && this.eleAutocomplete) {
      this.eleAutocomplete.style.overflow = "auto";
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();

    this.removeScrollEventListener();
  }

  onScroll(event: Event) {
    if (this.thresholdPercent === undefined) {
      this.scroll.next({ autoComplete: this.autoComplete, scrollEvent: event });
    } else {
      let ele = (<HTMLInputElement>event.target);
      const threshold = this.thresholdPercent * 100 * ele.scrollHeight / 100;
      const current = ele.scrollTop + ele.clientHeight;

      if (current > threshold && !this.disableLoading) {
        this.scroll.next({ autoComplete: this.autoComplete, scrollEvent: event });
        ele.style.overflow = "hidden";
      }
    }
  }

}
